import WidgetCollection from './WidgetCollection';

export {
    WidgetCollection
};



// WEBPACK FOOTER //
// ./plugins/slicer_cli_web/web_client/collections/index.js